import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarDays, List as ListIcon, Map } from 'lucide-react';

export type CalendarViewMode = 'calendar' | 'map' | 'list';

type CalendarViewSwitcherProps = {
  instancePrefix: string;
  active: CalendarViewMode;
};

const MODES: Array<{ mode: CalendarViewMode; title: string; Icon: typeof CalendarDays }> = [
  { mode: 'calendar', title: 'Kalender', Icon: CalendarDays },
  { mode: 'list', title: 'Liste', Icon: ListIcon },
  { mode: 'map', title: 'Karte', Icon: Map },
];

export function CalendarViewSwitcher({ instancePrefix, active }: CalendarViewSwitcherProps) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-1 rounded-md bg-app-surface-muted p-0.5">
      {MODES.map(({ mode, title, Icon }) => {
        const isActive = active === mode;
        return (
          <button
            key={mode}
            type="button"
            className={
              isActive
                ? 'rounded-md bg-app-surface p-1.5 text-pipedrive-blue shadow-sm'
                : 'rounded-md p-1.5 text-app-text-subtle hover:text-app-text'
            }
            title={title}
            aria-label={title}
            aria-current={isActive ? 'page' : undefined}
            onClick={() => {
              if (!isActive) navigate(`${instancePrefix}/calendar/${mode}`);
            }}
          >
            <Icon className="h-4 w-4" />
          </button>
        );
      })}
    </div>
  );
}
